import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal } from 'semantic-ui-react'
import { useTextResources } from '../../language';
import ApplicationContext from '../../context';
import {
    onSuccess,
    onError,
} from '../../components/shared/messages';
import { CreateRoomKey, CopyRoomKey } from '../../api/services/agent';

const CreateRoomKeyPopup = ({ reservation, ...rest }) => {
    const text = useTextResources();
    const [isOpen, setIsOpen] = useState(rest.open);
    const [isLoading, setLoading] = useState(false);
    const [numberOfCopies, setNumberOfCopies] = useState(2);

    const {
        state: { agentUrl },
    } = useContext(ApplicationContext);

    const getPreparedData = () => {
        const {
            Room, // Room with Number
            Guest, // FirstName
            Agent, // Name
            CheckOutDate,
            HotelId,
        } = reservation;

        const data = {
            roomNumber: Room?.Number ?? "",
            guestNameOrReceptionistName: Guest?.FirstName ?? Agent.Name ?? "",
            checkOutDateTime: CheckOutDate,
            numberOfCopies: numberOfCopies,
            hotelId: HotelId,
            roomId: Room?.Id,
        };

        return data;
    };

    const create = async () => {
        try {
            setLoading(true);

            var data = getPreparedData();
            var result = await CreateRoomKey(data, agentUrl);

            if (result && result.IsSuccessful) {
                onSuccess('RoomKeyWasCreated');
            } else {
                onError(text("RoomKeyWasNotCreated") + " " + result?.Error);
            }
        } catch (error) {
            onError(error);
        } finally {
            setLoading(false);
            closeHandler();
        }
    };

    const copy = async () => {
        try {
            setLoading(true);

            var data = getPreparedData();
            var result = await CopyRoomKey(data, agentUrl);

            if (result && result.IsSuccessful) {
                onSuccess('RoomKeyWasCopied');
            } else {
                onError(text('RoomKeyWasNotCopied') + " " + result?.Error);
            }
        } catch (error) {
            onError(error);
        } finally {
            setLoading(false);
            closeHandler();
        }
    };

    const handleChange = (event) => {
        const newValue = event.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
        const parsedNumber = parseInt(newValue, 10);
        setNumberOfCopies(isNaN(parsedNumber) ? 0 : parsedNumber);
    };

    const closeHandler = () => {
        setNumberOfCopies(2);
        rest?.onClose?.();
        setIsOpen(false);
    }

    return (
        <Modal open={isOpen} {...rest} size='small' >
            <Modal.Header>{text("NewRoomKey")}</Modal.Header>
            <Modal.Content style={{ maxHeight: 350, overflowY: "auto" }}>
                <Form>
                    <Form.Input
                        required
                        label={text("NumberOfCopies")}
                        value={numberOfCopies}
                        onChange={handleChange}
                    />
                </Form>

            </Modal.Content>
            <Modal.Actions>
                <Button
                    negative
                    size="small"
                    onClick={closeHandler}
                >
                    {text("Cancel")}
                </Button>
                <Button
                    disabled={!numberOfCopies || isLoading}
                    positive
                    size="small"
                    onClick={copy}
                >
                    {text('CopyRoomKey')}
                </Button>
                <Button
                    disabled={!numberOfCopies || isLoading}
                    positive
                    size="small"
                    onClick={create}
                >
                    {text('NewRoomKey')}
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

CreateRoomKeyPopup.propTypes = {
    reservation: PropTypes.object
}

export default CreateRoomKeyPopup

